<div class="subtitle-transcript-filter-dialog-container">
    <p-checkbox [(ngModel)]="displayOtonOnly" (onChange)="setDisplayOtonOnly()"
        [binary]="true" ariaLabel="Nur O-Töne anzeigen" inputId="oton-filter"></p-checkbox>
    <label for="oton-filter" class="checkbox-label">Nur O-Töne anzeigen</label>
</div>